import { Divider, Box, Text } from '@cad-arc';
import { SectionTitle } from '../../fr-event-common-components/section-title';
import { ASSIGNMENT_MODAL_COMMON_SIZE, ASSIGNMENT_MODAL_PADDING_TOP } from '../constants';
import { RadioChannelOption } from '@mark43/cad-api';
import { DataPrivacy } from '../../common/components/datadog-privacy';

export function AssignmentModalDetailsRadioChannel({
    radioChannel,
    additionalRadioChannels,
    unmask = false,
}: {
    radioChannel?: RadioChannelOption;
    additionalRadioChannels?: RadioChannelOption[];
    // Unmask the whole Radio Channel section (label + value) for Datadog Session Replay — not PII
    // (RND-53990). Default false keeps it masked for other consumers of this component.
    unmask?: boolean;
}) {
    if (!radioChannel) {
        return null;
    }

    const privacy = unmask ? 'unmask' : 'passthrough';
    return (
        <DataPrivacy privacy={privacy}>
            <Box>
                <SectionTitle title="Radio Channel" />
                <Text fontSize={ASSIGNMENT_MODAL_COMMON_SIZE}>{radioChannel.label}</Text>
                <Box alignItems="left">
                    {!!additionalRadioChannels?.length && (
                        <Text fontSize={ASSIGNMENT_MODAL_COMMON_SIZE}>Additional:</Text>
                    )}
                    {additionalRadioChannels?.map((additionalRadioChannel) => (
                        <Text
                            fontSize={ASSIGNMENT_MODAL_COMMON_SIZE}
                            key={additionalRadioChannel.label}
                        >
                            {additionalRadioChannel.label}
                        </Text>
                    ))}
                </Box>
                <Divider style={ASSIGNMENT_MODAL_PADDING_TOP} />
            </Box>
        </DataPrivacy>
    );
}
